import script from "./GuildMembersList.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuildMembersList.vue?vue&type=script&setup=true&lang=ts"

import "./GuildMembersList.vue?vue&type=style&index=0&id=291aea0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-291aea0c"]])

export default __exports__